// IBSIX tee PDP: keep the Kiwi Sizing "Size Chart" button after a variant change.
// Dawn re-renders <variant-selects> from the server on every option click, which drops the
// button Kiwi injected into the Size legend (live theme had the same bug, 2026-09-30).
// Re-attach the same node, so Kiwi's own click handler keeps working.
(() => {
  const root = document.querySelector('product-info.ibx-pdp');
  if (!root) return;
  let saved = null;

  const sizeLegend = () =>
    [...root.querySelectorAll('variant-selects fieldset legend')].find((l) => /^\s*size/i.test(l.textContent));

  const sync = () => {
    const current = root.querySelector('variant-selects .ks-chart-container');
    if (current) {
      saved = current;
      return;
    }
    const legend = saved && sizeLegend();
    if (legend) legend.append(saved);
  };

  new MutationObserver(sync).observe(root, { childList: true, subtree: true });
  sync();
})();
